import { render, staticRenderFns } from "./AppSystemSettings.vue?vue&type=template&id=470bd4ee&scoped=true"
import script from "./AppSystemSettings.vue?vue&type=script&lang=js"
export * from "./AppSystemSettings.vue?vue&type=script&lang=js"
import style0 from "./AppSystemSettings.vue?vue&type=style&index=0&id=470bd4ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470bd4ee",
  null
  
)

export default component.exports